import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import './semantic-ui.custom.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';


createRoot(document.getElementById('root')).render(
  //<StrictMode>
    <App />
  //</StrictMode>,
)

registerServiceWorker();